import { useEffect, useState } from "react";
import { IconCheckCircle, IconCopy } from "./icons";
import { Tooltip, type TooltipProps } from "./tooltip";

const copy = async (text: string) => {
  if (typeof navigator === "undefined") return;
  if (typeof navigator.clipboard === "undefined") return;
  await navigator.clipboard.writeText(text);
};

export const CopyText = ({
  text,
  children,
}: { text: string; children?: React.ReactNode }) => {
  return (
    <div className="flex items-center gap-2">
      <div>{children ? children : text}</div>
      <CopyTextButton text={text} />
    </div>
  );
};

export const CopyTextButton = ({
  text,
  label = "Copy",
  successIconOnCopy = false,
  color = "#888C90",
  ...tooltipProps
}: {
  text: string;
  label?: string;
  successIconOnCopy?: boolean;
  color?: string;
} & Omit<TooltipProps, "children" | "text">) => {
  const [success, setSuccess] = useState(false);
  const onClick = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();

    copy(text).then(() => {
      setSuccess(true);
    });
  };

  useEffect(() => {
    if (!success) return;

    const timer = setTimeout(() => {
      setSuccess(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, [success]);

  const showSuccessIcon = successIconOnCopy && success;

  return (
    <Tooltip text={success ? "Copied!" : label} {...tooltipProps} fluid>
      {showSuccessIcon ? (
        <IconCheckCircle
          variant="sm"
          className={"active:opacity-50"}
          color={color}
          onClick={(e) => onClick(e)}
        />
      ) : (
        <IconCopy
          variant="sm"
          className={"active:opacity-50"}
          color={color}
          onClick={(e) => onClick(e)}
        />
      )}
    </Tooltip>
  );
};
